// Brand assets and constants
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_b9576b55-74ab-4957-809e-0be3f9ff5830/artifacts/fpfwrdcm_IMG_0236.jpg";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1920&q=80",
  about: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1600&q=80",
  warehouse: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1600&q=80",
  production: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1600&q=80",
  team: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1600&q=80",
  careers: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1600&q=80",
};

export const COMPANY = {
  legal: "Genius WorkPA GmbH",
  street: "Elsenheimerstraße 15",
  zip: "80687",
  city: "München",
  country: "Deutschland",
  email: "info@genius-workpa.com",
  // Munich HQ coordinates for map embed
  hq: { lat: 48.1408, lng: 11.5328 },
};
